import React from 'react';
import { familleCompte } from '../../lib/modulesCatalog';
import { Building2, User, Users as UsersIcon } from 'lucide-react';
import { PrestationNotificationsSettings } from '../PrestationPlanning/PrestationNotificationsPage';
import { ClientEmailNotificationsSettings } from './ClientEmailNotificationsSettings';
import { ModeNotificationsContext } from '../ui/LigneNotification';
import { Segmented } from '../ui/Field';

type Destinataire = 'client' | 'salarie' | 'etablissement';

/**
 * Onglet Paramètres > Notifications (refonte du 2026-10-20, sur le modèle de ZenChef) : un seul filtre
 * « à qui ça part », puis la liste des emails, une ligne chacun. Les deux écrans d'avant (emails du
 * Planning de prestation, emails des autres modules) sont rendus l'un sous l'autre, sans leurs propres
 * onglets ni boutons « Enregistrer » : chaque ligne s'enregistre elle-même.
 */
export function NotificationsOnglet({ activeModules, clientType, voirPrestation, voirAutres }: {
    activeModules: string[];
    clientType?: string | null;
    voirPrestation: boolean;
    voirAutres: boolean;
}) {
    const a = (m: string) => activeModules.includes(m);
    const aSalarie = voirPrestation || a('demande_conges') || a('evenementiel') || a('portail_salarie') || (a('rdv_pro') && familleCompte(clientType) === 'restauration');
    const options: { value: Destinataire; label: React.ReactNode }[] = [
        { value: 'client', label: <span className="inline-flex items-center gap-1.5"><User size={13} /> Clients</span> },
        ...(aSalarie ? [{ value: 'salarie' as Destinataire, label: <span className="inline-flex items-center gap-1.5"><UsersIcon size={13} /> Salariés</span> }] : []),
        ...(voirPrestation ? [{ value: 'etablissement' as Destinataire, label: <span className="inline-flex items-center gap-1.5"><Building2 size={13} /> Vous</span> }] : []),
    ];
    const [destinataire, setDestinataire] = React.useState<Destinataire>('client');

    return (
        <ModeNotificationsContext.Provider value={{ enLignes: true }}>
            <div className="max-w-3xl space-y-6">
                <div className="space-y-3">
                    <p className="text-[13px] text-content-muted">
                        Les emails envoyés automatiquement ou depuis un bouton. L'interrupteur active ou coupe un email ;
                        cliquez sur un titre pour modifier son texte et voir ce que reçoit le destinataire.
                    </p>
                    {options.length > 1 && (
                        <Segmented value={destinataire} options={options} onChange={(v) => setDestinataire(v as Destinataire)} ariaLabel="Destinataire des emails" />
                    )}
                </div>
                {voirPrestation && <PrestationNotificationsSettings activeModules={activeModules} destinataire={destinataire} />}
                {voirAutres && <ClientEmailNotificationsSettings activeModules={activeModules} clientType={clientType} destinataire={destinataire} />}
            </div>
        </ModeNotificationsContext.Provider>
    );
}
